export default __webpack_public_path__ + "static/media/029.c94162d9.jpg";